import { gql } from "apollo-boost";

export const GET_HOME_OWNER_NAMES = gql`
  query GetHomeOwnerNames($property_id: ID!) {
    home_claim(input: { property_id: $property_id }) {
      owner_names
    }
  }
`;
